import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
// import PropTypes from "prop-types";

import {
  featuresSetupUpdateFeatures,
  featuresSetupShowMarkUpDownPopup,
} from "../featuresActions";
import {useMarkUpContext} from "./FeaturesSetupMarkUpContext";
import {getFilteredFeatures} from "../featuresFunctions";
import {setQuestionPopupState} from "../../../actions/A_Popups";
import {getParsedMarkUpLogic, getSameApplyTo} from "./markUpFunctions";


const FeaturesSetupMarkPopupSaveButton = (props) => {

  const {featuresSetupShowMarkUpDownPopup, featuresSetupUpdateFeatures, selectedFeaturesList, setQuestionPopupState,
    intl} = props;
  const {markUpDownContextState} = useMarkUpContext();
  // const {markUpList, activeMarkUpItemIndex, markUpDownInputValue, upDownCheckboxValue, applyToValue, currencyPercentageCheckboxValue}
  const {markUpList, activeMarkUpItemIndex, markUpDownInputValue} = markUpDownContextState;

  const saveDisabled = activeMarkUpItemIndex < 0 || !markUpList[activeMarkUpItemIndex] || !markUpDownInputValue
    || !selectedFeaturesList.length;

  const saveApply = () => {
    const markUpListItem = markUpList[activeMarkUpItemIndex];
    // const applyToFeatures = markUpListItem.isCustom ? selectedFeaturesList : delivery.features;
    const applyToFeatures = selectedFeaturesList;
    if (applyToFeatures && applyToFeatures.length) {
      featuresSetupUpdateFeatures("markUpLogic", markUpListItem, applyToFeatures)
    }
    featuresSetupShowMarkUpDownPopup(false);
  }

  const someFeatureHasAlreadyMarkUpLogic = () => {
    return selectedFeaturesList.some(feature => {
      const parsedMarkUpLogic = getParsedMarkUpLogic(feature);
      if (!parsedMarkUpLogic) {
        return false
      }
      const markUpListItem = markUpList[activeMarkUpItemIndex];
      return parsedMarkUpLogic.some(markUpItem => {
        if (markUpItem.id === markUpListItem.id) {
          return false
        }
        return getSameApplyTo(markUpListItem.applyTo, markUpItem.applyTo)
      })
    })
  }

  const saveClick = () => {
    if (saveDisabled) {
      return false
    }
    if (someFeatureHasAlreadyMarkUpLogic()) {
      setQuestionPopupState({
        className: "ui-popup--question--with-border",
        showPopup: true,
        questionMessage: intl.formatMessage({id: "features.setup.markUpDownPopup.replaceQuestion"}),
        yesClick: saveApply,
        noClick: null,
      })
      return false
    }
    //todo add check here
    saveApply();
  }

  return (
    <button className={"ui-button5 ui-button5--green relative" + (saveDisabled ? " ui-button5--disabled" : "")}
            onClick={saveClick}>
      <FormattedMessage id="features.setup.shippingSetupPopup.assignButton"/>
      {saveDisabled ? null : <span className="updateCount updateCount--small">{selectedFeaturesList.length}</span>}
    </button>
  )
};

// FeaturesSetupMarkPopupSaveButton.propTypes = {
//   updateButton: PropTypes.bool
// }

const mapStateToProps = (store) => {
  // const featuresList = getFilteredFeatures(store, false, true);
  const selectedFeaturesList = getFilteredFeatures(store, true, true);

  return {
    // featuresList,
    selectedFeaturesList,
  };
};

const mapDispatchToProps = {
  featuresSetupShowMarkUpDownPopup,
  featuresSetupUpdateFeatures,
  setQuestionPopupState,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupMarkPopupSaveButton)
)
